<template>
  <div id="resBox">
    <div class="resListBox">
      <div class="listItem" v-for="(item,index) in data" :key="index">
        <div class="resListName">{{item.name}}</div>
        <div class="listBox">
          <div class="listItemCon">
           <!-- <div class="itemName">{{n.conName}}</div> -->
            <div class="itemName" @click="toResoures(item.subjectId,'SynchronizeResources')">{{item.conSy}}</div>
            <div class="itemName" @click="toResoures(item.subjectId,'questionBank')">{{item.conQus}}</div>
            <div class="itemName" @click="toResoures(item.subjectIdStr,'testPaper')">{{item.conPage}}</div>
            <div class="itemName" @click="toResoures(item.subjectId,'MicroClass')">{{item.conVideo}}</div>
            <div class="itemName" @click="toResoures(item.packageId,'OpenClass')">{{item.conOpen}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  export default {
    name: 'index',
    data() {
      return {
        data: [{
            name: '数学',
            subjectId:80,
            subjectIdStr:'ff80808127d77caa0127d7e10f1c00c4',
            gradeId:83,                                     //初二
            gradeIdStr:'29646e10bec311e3a26400215e3f0e60',
            versionId:4,
            conName: '小学',
            conSy: '同步资源',
            conQus: '题库',
            conPage: '卷库',
            conVideo: '微课',
            packageId:9,
            conOpen:'公开课',
            id: 1
          },
          {
            name: '语文',
            subjectId:79,
            subjectIdStr:'ff80808127d77caa0127d7e13be500c6',
            gradeId:83,                                     //初二
            gradeIdStr:'29646e10bec311e3a26400215e3f0e60',
            versionId:5,
            conName: '小学',
            conSy: '同步资源',
            conQus: '题库',
            conPage: '卷库',
            conVideo: '微课',
            packageId:8,
            conOpen:'公开课',
            id: 2
          },
          {
            name: '英语',
            subjectId:81,
            subjectIdStr:'ff80808127d77caa0127d7e164bd00c8',
            gradeId:83,                                     //初二
            gradeIdStr:'29646e10bec311e3a26400215e3f0e60',
            versionId:4,
            conName: '小学',
            conSy: '同步资源',
            conQus: '题库',
            conPage: '卷库',
            conVideo: '微课',
            packageId:10,
            conOpen:'公开课',
            id: 3
          },
          {
            name: '物理',
            subjectId:82,
            subjectIdStr:'ff80808127d77caa0127d7e199bc00cb',
            gradeId:83,                                     //初二
            gradeIdStr:'29646e10bec311e3a26400215e3f0e60',
            versionId:4,
            conName: '小学',
            conSy: '同步资源',
            conQus: '题库',
            conPage: '卷库',
            conVideo: '微课',
            packageId:11,
            conOpen:'公开课',
            id: 4
          },
          {
            name: '化学',
            subjectId:83,
            subjectIdStr:'ff80808127d77caa0127d7e1e29c00ce',
            gradeId:83,                                     //初二
            gradeIdStr:'29646e10bec311e3a26400215e3f0e60',
            versionId:4,
            conName: '小学',
            conSy: '同步资源',
            conQus: '题库',
            conPage: '卷库',
            conVideo: '微课',
            packageId:12,
            conOpen:'公开课',
            id: 5
          },
        ]

      }
    },
    methods: {
      toOpen(subjectId,name) {
        this.$router.push({
          name: name
        });
        this.$emit('indexOpenTab', {'isFromIndexOpenTab':name,'subjectId':subjectId,'routerMicroName':name});
      },
      toResoures(subjectId,name){
        this.$router.push({name: name});
        this.$emit('indexResourse', {'isFromIndexSyn':name,'subjectId':subjectId,'routerMicroName':name});
      }
    }
  }
</script>
<style scoped>
  .resListBox {
    float: left;
    width: 116px;
    background: rgba(0, 0, 0, 0.6);
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 6px 6px;
  }

  .resListName {
    width: 116px;
    height: 49px;
    line-height: 50px;
    text-align: center;

    color: #FFFFFF;
    border-bottom: 1px solid #D8D8D8;
  }

  .listItem {
    position: relative;
    cursor: pointer;
    height: 50px;
  }

  .listItem:hover .listBox {
    display: block;
  }

  .listItem:last-of-type .resListName {
    border-bottom: none;
  }

  .listBox {
    width: 320px;
    position: absolute;
    left: 116px;
    top: 0;
    background-color: #fff;
    padding-left: 20px;
    border-radius: 0px 6px 6px 0px;
    display: none;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
  }
  /* .listItem:last-of-type .listBox {
    bottom: 0;
    top: auto;
  } */
  .listItemCon {
    display: flex;
    flex-direction: row;
    height: 49px;
    border-bottom: 1px solid #EEEEEE;
  }

  .listItemCon:last-of-type {
    border-bottom: none;
  }

  .itemName {
    margin-right: 20px;
    line-height: 50px;
    cursor: pointer;
    font-size: 14px;
  }
/*
  .itemName:first-of-type {
    color: #3583FF;
  } */

  .itemName:hover {
    color: #3583FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/LeftTabs.vue